const SPPX_TOKEN_ERROR_MEMOS = new Set([
  "Bearer token not found",
  "Bearer Token Not OK",
  "Expired token",
  "Missing Bearer Token",
]);

export function isSppxTokenErrorPayload(payload) {
  const status = payload && payload.status;
  return Boolean(
    status &&
      String(status.code) === "401" &&
      SPPX_TOKEN_ERROR_MEMOS.has(status.memo)
  );
}

export function isSppxAuthEndpoint(config = {}) {
  const url = String(config.url || "");
  return url.includes("/api/sppx-refresh-token") || url.includes("/api/sppx-login");
}

function cloneRequestData(data) {
  if (!data) return {};
  if (typeof FormData !== "undefined" && data instanceof FormData) {
    const formData = new FormData();
    data.forEach((value, key) => formData.append(key, value));
    return formData;
  }
  if (typeof data === "string") {
    try {
      return JSON.parse(data);
    } catch (_error) {
      return {};
    }
  }
  if (typeof data === "object") {
    return { ...data };
  }
  return {};
}

export function buildSppxRetryConfig(config = {}, sppxToken) {
  const data = cloneRequestData(config.data);
  if (typeof FormData !== "undefined" && data instanceof FormData) {
    data.set("sppx_token", sppxToken);
  } else {
    data.sppx_token = sppxToken;
  }
  return {
    ...config,
    _sppxRetry: true,
    data,
  };
}
